/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import Part from '../Part';
import ButtonPrimary from '../../common/ButtonPrimary';

const ListItem = ({ item, onEditClick, onDeleteClick, index }) => {
  return (
    <div className="dashboard-listitem">
      <div className="dashboard-listitem_top">
        <div className="dashboard-listitem_left">
          <div className="dashboard-listitem_thumbnail_wrap">
            <div
              className="dashboard-listitem_thumbnail"
              style={{
                backgroundImage: `url(${item.thumbnail})`
              }}
            />
            {item.orderPlaced && <ButtonPrimary label="Ordered" customClasses="dashboard-listitem_badge" />}
          </div>

          <div className="dashboard-listitem_action-mob">
            <h1 className="dashboard-listitem_btmtitle dashboard-listitem_btmtitle-mob">
              make your own {index + 1}
            </h1>
            <div className="dashboard-listitem_price-mob">
              {item.totalPrice}
            </div>
            <div className="dashboard-listitem_btns-mob">
              <ButtonPrimary label="edit" onClick={onEditClick} />
              {/* <ButtonPrimary
                label="add to cart"
                onClick={() => {
                  console.log('add to cart');
                }}
              /> */}
              <ButtonPrimary label="remove" onClick={onDeleteClick} />
            </div>
          </div>
        </div>
        <div className="dashboard-listitem_right">
          <div className="dashboard-listitem_list">
            {item.partsConfig.map((part, i) => (
              <Part
                key={i}
                category={part.category}
                icon={part.icon}
                selectedOption={
                  part.category === 'bikeArtFront' ||
                    part.category === 'bikeArtBack'
                    ? part.selectedAngle
                    : part.selectedOption
                }
              />
            ))}
          </div>
        </div>
      </div>
      <div className="dashboard-listitem_btm">
        <h1 className="dashboard-listitem_btmtitle">
          make your own {index + 1}
          <span>{item.totalPrice}</span>
        </h1>
        <div className="dashboard-listitem_btns">
          <ButtonPrimary label="edit" onClick={onEditClick} />
          {/* <ButtonPrimary
            label="add to cart"
            onClick={() => {
              console.log('add this to cart');
            }}
          /> */}
          <ButtonPrimary label="remove" onClick={onDeleteClick} />
        </div>
      </div>
    </div>
  );
};

ListItem.propTypes = {
  item: PropTypes.object,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func
};

export default ListItem;
